module.exports = __webpack_public_path__ + "static/media/Female07.b4c7eb0a.jpg";